/**
 * expose a method for Ethos to get template/symbol version
 */
export { getSettings } from './components/DataProvider/DataProvider';
